import React, { ChangeEvent, useEffect, useState } from "react";
import AuthLayout from "../../../Layout/AuthLayout";
import { Link } from "react-router-dom";
import { useLoginUser } from "../../../hooks/Auth/useLoginUser";
import { useHandshakeQuery } from "../../../hooks/useHandshakeQuery";
import Input from "../../../Components/Input";
import Button from "../../../Components/Button";

const Login = () => {
  const [payload, setPayload] = useState({
    email: "",
    password: "",
  });

  const [validity, setValidity] = useState(false);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPayload({ ...payload, [name]: value });
  };

  useEffect(() => {
    const { email, password } = payload;
    setValidity(!!(email && password));
  }, [payload]);

  const { mutateAsync, isPending: isLoading } = useLoginUser(payload);

  const submitForm = () => {
    if (validity) {
      mutateAsync();
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      subTitle="Enter your details below to access the admin portal"
      back={false}
    >
      <Input
        label={"Email Address"}
        name={"email"}
        type={"email"}
        disabled={isLoading}
        value={payload?.email}
        placeholder={"Enter Email"}
        onChange={handleInputChange}
      />
      <Input
        label={"Password"}
        name={"password"}
        type={"password"}
        disabled={isLoading}
        value={payload?.password}
        placeholder={"Enter Password"}
        onChange={handleInputChange}
        right={
          <Link to="/forgot-password" className="text-orange">
            Forgot Password?
          </Link>
        }
      />
      <Button
        onClick={submitForm}
        disabled={!payload?.email || !payload?.password}
        isLoading={isLoading}
        label={"Sign in"}
      />
      {/* <label
        htmlFor="password"
        className="text-grey flex justify-between items-center"
      >
        <span>Password</span>
        <Link to="/forgot-password" className="text-orange">
          Forgot Password?
        </Link>
      </label> */}
      {/* <div className="relative">
        <input
          name="password"
          type={passwordVisibility ? 'text' : 'password'}
          value={payload.password}
          onChange={handleInputChange}
          disabled={isLoading}
          placeholder="************"
          className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        />
        <span
          onClick={() => setPasswordVisibility(!passwordVisibility)}
          className="cursor-pointer absolute right-[15px] top-[30px]"
        >
          {passwordVisibility ? <InVisible /> : <Visible />}
        </span>
      </div> */}

      {/* <button
        disabled={!validity}
        onClick={submitForm}
        className={`text-white p-[23px] w-full font-bold rounded-md ease-in-out duration-300 ${
          validity === false ? 'bg-brown opacity-50' : 'bg-orange'
        } ${isLoading && 'opacity-50'}`}
      >
        {isLoading ? 'Submitting' : 'Sign in'}
      </button> */}
    </AuthLayout>
  );
};

export default Login;

const Visible = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    />
  </svg>
);

const InVisible = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  </svg>
);
